export default __webpack_public_path__ + "static/media/laptop.f8260aff.jpeg";